var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLunaDarkMode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 18 18",
    fill: "red",
    xmlns: "http://www.w3.org/2000/svg",
    size: 18,
    stroke: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.93652 8.81528C3.93652 11.7148 6.28703 14.0653 9.18652 14.0653C11.3957 14.0653 13.2862 12.7007 14.0611 10.7686C13.4565 11.0116 12.7948 11.1486 12.1032 11.1486C9.20367 11.1486 6.85319 8.79807 6.85319 5.89857C6.85319 5.21021 6.98814 4.54475 7.22898 3.94238C5.29904 4.7184 3.93652 6.60773 3.93652 8.81528Z",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "transparent",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLunaDarkMode);
export default __webpack_public_path__ + "static/media/lunaDarkMode.abe35a7e037942d56980d722170eb3ee.svg";
export { ForwardRef as ReactComponent };